import {createContext } from 'react';

export const AuthContext = createContext(); // aqui puede ir el token?????


